import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const BuyerInfoContext = createContext();

export const BuyerInfoProvider = ({ children }) => {
	const [buyerInfo, setBuyerInfo] = useState({
		buyerFullName: '',
		buyerPhone: '',
		buyerEmail: '',
		buyerAddress: {
			addressString: '',
			addressLineOne: '',
			addressLineTwo: '',
			city: '',
			county: '',
			state: '',
			zip: '',
		},
	});

	const value = useMemo(() => ({ buyerInfo, setBuyerInfo }), [buyerInfo]);

	return <BuyerInfoContext.Provider value={value}>{children}</BuyerInfoContext.Provider>;
};

BuyerInfoProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default BuyerInfoContext;
